import { BaseRenderer } from '@/modules/core/ui/renderers/BaseRenderer';

export class FloatLabelPresenter extends BaseRenderer {
  getFormElement(): Element | null {
    return this.element.querySelector('input, textarea, select');
  }

  getLabelElement(): Element | null {
    return this.element.querySelector('label');
  }

  dispatchInputEvent(element: Element): void {
    const event: Event = new Event('input', { bubbles: true, cancelable: false });
    element.dispatchEvent(event);
  }
}
